import React from 'react';
import _ResponsiveProductTab from 'src/components/Modules/ResponsiveProductTab';

import ContentGroupHOC from '../HOC';
import { compose } from 'redux';
// import { separateSymbol } from 'src/tools/constant';
// import { errKeys } from 'src/constrains/DraggableModules/tools';
import { ContentModuleGroupPreloadingContext } from 'src/constrains/DraggableModules/PreloadComponent/SubscriptionPreloading';

const ResponsiveProductTab = (props) => {
  const {
    staticData,
    dynamicData,
    handleOnReselect,
    handleItemOnChange,
    handleItemOnSort,
    handleOnStaticsChange,
    linkSet,
    specificError,
    droppableId,
    extraProps,
    handleItemOnAdd,
    handleOnItemDelete,
  } = props || {};
  const { breakpoint } = extraProps || {};
  //console.log('specificError', specificError);
  const { buttons, animations, hoverAnimations } = React.useContext(
    ContentModuleGroupPreloadingContext,
  );
  // const layersKey = errKeys.ResponsivePoster.imageLayers;
  // const layersError = Object.keys(specificError || {}).reduce((pre, key) => {
  //   // console.log('key', key);
  //   const isLayerError =
  //     key.startsWith(layersKey) && (specificError[key] || []).length > 0;
  //   if (isLayerError) {
  //     const id = key.split(separateSymbol)[1];
  //     return { ...pre, [id]: true };
  //   }
  //   return pre;
  // }, {});
  return (
    <_ResponsiveProductTab
      onItemDelete={handleOnItemDelete}
      staticData={staticData}
      tabs={dynamicData}
      onItemAdd={handleItemOnAdd}
      onItemReselect={handleOnReselect}
      onItemChange={handleItemOnChange}
      onItemSort={handleItemOnSort}
      onStaticChange={handleOnStaticsChange}
      linkSet={linkSet}
      specificError={specificError}
      droppableId={droppableId}
      breakpoint={breakpoint}
      animations={animations}
      hoverAnimations={hoverAnimations}
      buttons={buttons}
    />
  );
};
export default compose(ContentGroupHOC)(ResponsiveProductTab);
